import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const marketingAgentPromptGoalSchema_ = z.object({
  _id: zExt.objectId(),
  typeId: z.string().optional(),
  version: z.number(),
  prompt: z.string(),
  displayLabel: z.string(),
  displayDescription: z.string().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
  disabledAt: z.date().nullish(),
});

export const marketingAgentPromptGoalSchema: z.ZodType<MarketingAgentPromptGoal> =
  marketingAgentPromptGoalSchema_;
export interface MarketingAgentPromptGoal
  extends z.infer<typeof marketingAgentPromptGoalSchema_> {}
